<template>
  <div>
    <!-- <pre>{{shortStaffList}}</pre> -->

    <!-- {{checkPaymentApproval}} -->

    <vs-popup
      class="popup"
      title="Generate Pay Slip"
      :active.sync="generatePaySlipModal"
    >
      <!--  <RearrangeManagement
         v-if="columnRearrangementModal"
         moduleProps="Leads"
         ></RearrangeManagement> -->
      <staff-table
        @listenOpenSidebar="listenOpenSidebar"
        @afterPaid="afterPaid"
        v-if="generatePaySlipModal"
      ></staff-table>
    </vs-popup>

    <!--  {{users}}
      <pre>{{payoutData}}</pre> -->
    <!-- {{payid}} -->
    <vx-card title="Search View" class="mb-4" v-if="fromModule === 'admin'">
      <vs-row>
        <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
          <vs-row class="filter-holder">
            <vs-col class="p-1" vs-lg="6" vs-sm="12" vs-xs="12">
              <vs-input
                placeholder="Search"
                class="w-full"
                v-model="search"
                @keyup="searchFun"
                style="width: 100%"
              />

              <!-- {{staff_id}} -->
            </vs-col>
            <vs-col class="p-1" vs-lg="6" vs-sm="12" vs-xs="12">
              <v-select
                class="w-full"
                placeholder="Enter Staff Name"
                :options="shortStaffList"
                v-model="staff_id"
                :reduce="(item) => item.id"
                label="name"
              >
               <template v-slot:selected-option="shortStaffList">
                  <img
                    v-if="shortStaffList.picture"
                    class="person-img rounded-full"
                    :src="shortStaffList.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ shortStaffList.name }}
                </template> 
                  <template v-slot:option="shortStaffList">
                  <img
                    v-if="shortStaffList.picture"
                    class="person-img rounded-full"
                    :src="shortStaffList.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ shortStaffList.name }}
                </template>
              </v-select>

              <!-- {{staff_id}} -->
            </vs-col>
            <vs-col class="p-1" vs-lg="6" vs-sm="12" vs-xs="12">
              <!-- {{dateSearchRange}} -->
              <date-range-picker
                ref="picker"
                class="cstm_datePicker w-full"
                :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                :showWeekNumbers="true"
                :showDropdowns="true"
                :autoApply="true"
                :ranges="customDateRanges()"
                v-model="dateSearchRange"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  <span
                    v-if="
                      dateSearchRange.startDate === null ||
                      dateSearchRange.endDate === null"
                    style="
                      color: rgba(0, 0, 0, 0.5);
                      font-weight: 400;
                      font-size: 12px;"
                    >Select Date Range</span
                  >
                  <span v-else
                    >{{ picker.startDate | date }} -
                    {{ picker.endDate | date }}</span
                  >
                </template>
              </date-range-picker>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
          <div class="p-1 flex">
            <vs-button @click="runFilter" class="includeIcon includeIconOnly"
              >Go</vs-button
            >

            <vs-tooltip text="Reset">
              <vs-button
                @click="resetFilter"
                type="border"
                icon-pack="feather"
                icon="icon-refresh-ccw"
                class="ml-2 mr-2"
              ></vs-button>
            </vs-tooltip>

            <vs-button
              @click="generatePaySlipModal = true"
              class=""
              v-if="checkGeneratSlipApproval"
              >Generate Pay Slip</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </vx-card>
    <!-- {{selected}} -->
    <vs-button
      v-if="selected.length > 1 && checkDeletePermission"
      @click="bulkDelete()"
    >
      Bulk Delete
    </vs-button>

    <ag-grid-vue 
      ref="agGridTable"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :style="{ minHeight: meta.limit * 48 + 75 + 'px' }"
      :animateRows="true"
      :floatingFilter="false"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      :columnDefs="columnDefs"
       :defaultColDef="defaultColDef"
      :rowData="payoutData"
      rowSelection="multiple"
      @row-selected="onRowSelected"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
       @sortChanged="sortFun"
    />

    <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
      <vs-col
        vs-xs="12"
        vs-sm="6"
        vs-lg="4"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
      >
        <!-- page limit select view -->
        <ItemsPerTableDropdown
          tableName="staff_payment_list"
          @change="(pageLimit) => pageLimitSet = pageLimit"
        />
      </vs-col>
      <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
        <pagination
          style="float: right"
          :meta="meta"
          @page-change="handlePageChange"
        />
      </vs-col>
    </vs-row>

    <div class="full-cstm-sidebar mt-107" :class="{ open: paySlipSidebar }">
      <div class="mt-6 flex items-center justify-between px-6">
        <div>
          <h4 class="inline-flex whitespace-nowrap">Payslip</h4>
        </div>
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click="paySlipSidebar = false"
        />
      </div>
      <vs-divider class="mb-0" />

      <StaffpayoutDetails
        v-if="paySlipSidebar && payid"
        :pdf="false"
        :payid="payid"
      ></StaffpayoutDetails>
    </div>
    <div class="bg-overlay"></div>
    <!-- pdf print -->
    <!--  <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="Finance"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasDownloaded="hasGenerated($event)"
      ref="html2Pdf"
       :html-to-pdf-options="{
        margin: 10,
        filename: 'Finance',
        allowTaint: true,

        html2canvas: {
          dpi: 300,
          letterRendering: true,
          scrollX: 0,
          useCORS: true,
          scale: 1,
          scrollY: 0,
        },
      }"
    >
      <section slot="pdf-content">
        <StaffpayoutDetails
        v-if="paySlipSidebar && payid"
        :pdf="true"
        :payid="payid"
      ></StaffpayoutDetails>

        
      </section>
    </vue-html2pdf> -->
  </div>
</template>

<script>
import {
  getPayOutListApi,
  staffPaymentStatusUpdate,
  staffPaymentSentApi,
  staffListShortApi,
  staffDeleteApi,
  fetchStaffFinanceBySearch
} from '@/api/finance'
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import StaffpayoutDetails from './StaffpayoutDetails.vue'
import InvoiceSidebar from './InvoiceSidebar.vue'
import Pagination from '@/components/common/pagination'
import StaffTable from './StaffTable'
import VueHtml2pdf from 'vue-html2pdf'
import InvoicePreview from './InvoicePreview'
import { AgGridVue } from 'ag-grid-vue'
import FullNameCell from './staff_payment_table_cells/FullNameCell.vue'
import ShareCell from './staff_payment_table_cells/ShareCell.vue'
import ViewCell from './staff_payment_table_cells/ViewCell.vue'
import DeleteCell from './staff_payment_table_cells/DeleteCell.vue'
import StatusCell from './staff_payment_table_cells/StatusCell.vue'

export default {
  props: {
    users: {},
    dateRange: {},
    fromModule: {
      type: String,
      required: true,
      default: 'admin'
    },
    checkPaymentApproval: { type: Boolean, default: false },
    checkGeneratSlipApproval: { type: Boolean, default: false },
    checkDeletePermission: { type: Boolean, default: false }
  },
  components: {
    vSelect,
    DateRangePicker,
    Pagination,
    StaffpayoutDetails,
    InvoiceSidebar,
    StaffTable,
    VueHtml2pdf,
    InvoicePreview,
    AgGridVue,
    FullNameCell,
    ShareCell,
    ViewCell,
    DeleteCell,
    StatusCell
  },
  data () {
    return {
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      gridOptions: {
        accentedSort: true
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      gridApi: {},
      search: '',
      generatePaySlipModal: false,
      schoolAddress: null,
      platformCustomerInfo: null,
      invoiceSidebarData: null,
      invoiceSidebar: false,
      payoutData: [],
      paySlipSidebar: false,
      dateSearchRange: { startDate: null, endDate: null },
      payid: null,
      paymentStatus: [
        { id: 0, paymentName: 'Unpaid' },
        { id: 1, paymentName: 'Paid' }
      ],
      shortStaffList: [],
      staff_id: null,
      selected: [],
      pageLimitOPtion: [
        {
          name: 5,
          value: 5
        },
        {
          name: 10,
          value: 10
        },
        {
          name: 20,
          value: 20
        }
      ],
      pageLimitSet: 5,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10
      },
      columnDefs: [
        {
          headerName: '',
          minWidth: 60,
          field: 'isSelected',
          filter: false,
          checkboxSelection: () => {
            return true
          },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: 'Full Name',
          field: 'fullname',
          minWidth: 200,
          cellRendererFramework: 'FullNameCell'
        },
        {
          headerName: 'From Date',
          minWidth: 140,
          field: 'from_date',
          valueFormatter: params => this.$options.filters.dateFormatLocalization(params.data.from_date)
        },
        {
          headerName: 'To Date',
          minWidth: 140,
          field: 'to_date',
          valueFormatter: params => this.$options.filters.dateFormatLocalization(params.data.to_date)
        },
        {
          headerName: 'Per Hour Payment',
          minWidth: 165,
          field: 'per_hour_payment'
        },
        {
          headerName: 'Total Hour',
          minWidth: 120,
          field: 'total_hour'
        },
        {
          headerName: 'Total Payment',
          minWidth: 140,
          field: 'total_payment'
        }
      ]
    }
  },
  created () {
    this.staffListShort()
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.fromModule === 'admin' && this.checkPaymentApproval === true) {
      this.columnDefs.push({
        headerName: 'Status',
        field: 'status',
        minWidth: 180,
        maxWidth: 180,
        cellRendererFramework: 'StatusCell',
        comparator:(value) => {},
        CellRendererParams: {
          changeStatus: (data) => this.changeStatus(data)
        }
      })

      this.columnDefs.push({
        headerName: 'Share',
        field: 'share',
        minWidth: 90,
        maxWidth: 90,
        sortable: false,
        cellRendererFramework: 'ShareCell',
        CellRendererParams: {
          fromModule: this.fromModule,
          checkPaymentApproval: this.checkPaymentApproval,
          SharingPaySlip: (data, index) => this.SharingPaySlip(data, index)
        }
      })
    }

    this.columnDefs.push({
      headerName: 'View Pay Slip',
      field: 'view',
      sortable: false,
      minWidth: 120,
      cellRendererFramework: 'ViewCell',
      CellRendererParams: {
        paySlipSidebarFunction: (id) => this.paySlipSidebarFunction(id)
      }
    })

    if (this.fromModule === 'admin' && this.checkDeletePermission) {
      this.columnDefs.push({
        headerName: 'Action',
        field: 'action',
        minWidth: 100,
        maxWidth: 100,
        sortable: false,
        cellRendererFramework: 'DeleteCell',
        CellRendererParams: {
          deletePayslip: (id, data) => this.deletePayslip(id, data)
        }
      })
    }
  },
  watch: {
    paySlipSidebar () {
      if (!this.paySlipSidebar) {
        this.payid = null
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  methods: {
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId == 'class_name') {
        field_name = 'name'
      } else if (colId == 'class_teacher_name') {
        field_name = 'class_teacher'
      }
      return field_name
    },
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        console.log(sortState)
        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort

          this.fetchInvoiceListBySearch()
        }
      } catch (e) {}
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        const payload = {
          search: vm.search,
          customer_id: vm.$store.getters.customerId,
          limit: vm.pageLimitSet
        }

        const data = await fetchStaffFinanceBySearch(payload, vm.query_page)

        vm.payoutData = data.data.data.users
        vm.meta = data.data.data.meta
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    onRowSelected () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()

      if (selectedNodes) {
        const selectedNode = this.gridApi.getSelectedNodes()
        this.selected = selectedNode.map((node) => node.data)
      } else {
        this.selected = []
      }
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    handlePageChange (page) {
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = this.pageLimitSet
      this.query_page.page = page
      /* if (this.fromModule === 'admin') {
        const pageScroll = document.documentElement.scrollTop
        this.$router
          .replace({ path: '/staffpayout', query: queryPayload })
          .catch(() => {}).then(() => {
            document.documentElement.scrollTop = pageScroll
          })
      } else {
        const pageScroll = document.documentElement.scrollTop
        this.$router
          .replace({ path: '/staffpaidslip', query: queryPayload })
          .catch(() => {}).then(() => {
            document.documentElement.scrollTop = pageScroll
          })
      } */
      if (this.search !== '' || this.sorting_obj.attribute !== '') {
        this.fetchInvoiceListBySearch()
      } else if (this.staff_id !== null || this.dateSearchRange.startDate !== null) {
        this.runFilter()
       // this.getPayOutList()
      } else {
        this.fetchInvoiceListBySearch()
      }
      
    },
    async fetchInvoiceListBySearch () {
     
      try {
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId,
          limit: this.pageLimitSet
        }
        console.log(this.sorting_obj)
        const data = await fetchStaffFinanceBySearch(payload, this.query_page.page, this.sorting_obj)

        this.payoutData = data.data.data.users
        this.meta = data.data.data.meta
      } catch (e) {
        //
      }
    },
    bulkDelete () {
      const checkingApproved = this.selected.some((ele) => ele.approved === 1)
      if (checkingApproved) {
        this.showSuccessMessage(
          'error',
          'Shared payslip cant be deleted',
          'danger'
        )
      } else {
        const ids = this.selected.map((ele) => ele.id)
        this.deletePayslip(ids)
      }
      console.log(checkingApproved)
    },
    deletePayslip (id, index) {
      let ids = []
      if (Array.isArray(id)) {
        ids = id
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this unshared payslip ?',
          accept: this.deleteAlert,
          parameters: ids
        })
      } else if (this.payoutData[index].approved === 1) {
        this.showSuccessMessage(
          'error',
          'Shared Payslip cant be deleted',
          'danger'
        )
      } else {
        ids.push(id)

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this unshared payslip ?',
          accept: this.deleteAlert,
          parameters: ids
        })
      }

      // console.log(id)
    },
    async deleteAlert (id) {
      try {
        const payload = {
          ids: id
        }
        const customer_id = localStorage.getItem('customer_id')
        const data = await staffDeleteApi(customer_id, payload)
        this.payoutData = this.payoutData.filter((ele) => {
          return !id.includes(ele.id)
        })

        this.selected = []

        if (this.payoutData.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }

        this.showSuccessMessage('success', 'Deleted Successfully', 'success')
        console.log(payload)
      } catch (error) {
        console.warn(error)
      }
    },
    async staffListShort () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const { data } = await staffListShortApi(customer_id)
        this.shortStaffList = data.data.users
        console.log(data)
        // this.staffListShort = data
      } catch (err) {
        console.log(err)
      }
    },
    generateReport () {
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
      }, 1000)
    },
    onProgress (event) {
      this.percentage = event
      this.showPercentage = true

      if (event == 100) {
        this.showPercentage = false
      }
      //   if(event===100)
    },
    hasGenerated (event) {},
    async changeStatus (params) {
      try {
        const payload = {
          ids: [params.id],
          is_paid: params.is_paid
        }
        const customer_id = localStorage.getItem('customer_id')
        const data = await staffPaymentStatusUpdate(customer_id, payload)
        this.showSuccessMessage(
          'Success',
          'Status Change Successfully',
          'success'
        )
        console.log(data)
        console.log(params)
      } catch (err) {
        console.log(err)
      }
    },

    SharingPaySlip (params, index) {
      const paramsid = params.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Please Confirm',
        text: 'Are you sure you want to Share this payslip?',
        accept: this.acceptAlert,
        parameters: { paramsid, index }
      })
      console.log('PaySlip')
    },
    async acceptAlert ({ paramsid, index }) {
      console.log(paramsid)
      console.log(index)
      try {
        const customer_id = localStorage.getItem('customer_id')

        const payload = {
          ids: [paramsid]
        }
        await staffPaymentSentApi(customer_id, payload)
        this.payoutData[index].approved = 1
        this.showSuccessMessage('Success', 'Shared Successfully', 'success')
      } catch (error) {
        console.warn(error.message)
      }
      // console.log(id)
    },
    /*  generateReport () {
      console.log('hi')
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
      }, 1000)
    },
    onProgress (event) {
      console.log(event)
      this.percentage = event
      this.showPercentage = true

      if (event == 100) {
        this.showPercentage = false
      }
    }, */
    /*  openInvoiceSidebar () {
      this.invoiceSidebar = true
      document.body.classList.add('overflow-hidden')
    }, */
    handleinvoiceSidebar () {
      this.invoiceSidebar = false
      document.body.classList.remove('overflow-hidden')
    },
    listenOpenSidebar (invoiceData, schoolAddress, platformCustomerInfo) {
      console.log(platformCustomerInfo)
      console.log('hi')
      console.log(invoiceData)
      this.invoiceSidebarData = invoiceData
      this.schoolAddress = schoolAddress
      this.platformCustomerInfo = platformCustomerInfo
      // this.platform_customer=
      this.invoiceSidebar = true
      document.body.classList.add('overflow-hidden')
    },
    resetFilter () {
      this.search = null
      this.dateSearchRange.startDate = null
      this.dateSearchRange.endDate = null
      this.staff_id = null
      this.runFilter()
    },
    runFilter () {
      const payload = {
        user_id: this.staff_id,
        from_date: this.dateSearchRange.startDate
          ? this.$moment(this.dateSearchRange.startDate).format('YYYY-MM-DD')
          : null,
        to_date: this.dateSearchRange.endDate
          ? this.$moment(this.dateSearchRange.endDate).format('YYYY-MM-DD')
          : null
      }
      this.getPayOutList(false, payload)
      console.log('Run Filter')
    },
    paySlipSidebarFunction (id) {
      console.log(id)
      this.payid = id
      console.log(this.payid)
      this.paySlipSidebar = true
    },
    async getPayOutList (save = false, payload = {}) {
      try {
        /*  const payload = {
          'users': this.users,
          'from_date': this.$moment(this.dateRange.startDate).format(
            'YYYY-MM-DD'
          ),
          'to_date': this.$moment(this.dateRange.endDate).format(
            'YYYY-MM-DD'
          ),
          save
        } */
        this.query_page.limit = this.pageLimitSet
        const customer_id = localStorage.getItem('customer_id')
        // const payload = {}
        if (this.fromModule === 'onlystaff') {
          payload.is_paid = true
        }

        const data = await getPayOutListApi(
          customer_id,
          payload,
          this.query_page
        )
        this.payoutData = data.data.data.users
        this.meta = data.data.data.meta
        if (save) {
          this.showSuccessMessage(
            'Success',
            'Pay Out Generated Successfully',
            'success'
          )
        }
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    },
    afterPaid () {
      this.generatePaySlipModal = false
      this.getPayOutList()
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  }
}
</script>

<style>
.payment_stat_fin {
  border-radius: 20px;
}
.payment_stat_fin .vs__selected,
.payment_stat_fin .vs__dropdown-toggle {
  color: #fff;
  border: none;
}
.pay_status_0 {
  background: #ff9f43;
}
.pay_status_1 {
  background: #28c870;
}
.pay_shared {
  color: #28c870;
  opacity: 0.4;
}
</style>